"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const DataProvider_1 = tslib_1.__importDefault(require("../DataProvider"));
var BannerSubjectTypeEnum;
(function (BannerSubjectTypeEnum) {
    BannerSubjectTypeEnum["CREATOR"] = "creator";
    BannerSubjectTypeEnum["MEMBER"] = "member";
    BannerSubjectTypeEnum["PROFILE_HEADER"] = "profile_header";
    BannerSubjectTypeEnum["PROFILE_BUTTON"] = "profile_button";
    BannerSubjectTypeEnum["LANDING_PAGE"] = "landing_page";
    BannerSubjectTypeEnum["LIST_VIEW"] = "list_view";
    BannerSubjectTypeEnum["SEARCH_MINI_SLIDER"] = "search_mini_slider";
    BannerSubjectTypeEnum["JOBS_LANDING_PAGE"] = "jobs_landing_page";
    BannerSubjectTypeEnum["EVENTS_LANDING_PAGE"] = "events_landing_page";
    BannerSubjectTypeEnum["JOBS_LIST_VIEW"] = "jobs_list_view";
    BannerSubjectTypeEnum["EVENTS_LIST_VIEW"] = "events_list_view";
    BannerSubjectTypeEnum["EVENTS_MINI_SLIDER"] = "events_mini_slider";
})(BannerSubjectTypeEnum = exports.BannerSubjectTypeEnum || (exports.BannerSubjectTypeEnum = {}));
class BannersProvider extends DataProvider_1.default {
    get fragments() {
        return {
            Banner: () => `
        ... on Banner {
          id
          image {
            ${this.getFragment("File")}
          }
          link
          sort
          title
          subject {
            ${this.getFragment("Subject")}
          }
          hidden
          hideTime
          tagIds
        }
      `,
        };
    }
    findAll({ data }, fields) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.query("bannersFind", { data }, this.getFragment("Banner", fields));
        });
    }
    update({ data }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.mutate("bannerUpdate", { data }, this.getFragment("Banner"));
        });
    }
    create({ data }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.mutate("bannerUpdate", { data }, this.getFragment("Banner"));
        });
    }
    delete({ id }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.mutate("bannerDelete", { id });
        });
    }
}
exports.BannersProvider = BannersProvider;
//# sourceMappingURL=BannersProvider.js.map